<div class="modal-header">
    <h4 class="modal-title">İzin {{data.row ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="personLeaveForm">
        <div class="row">
            <div class="col-12" *ngIf="personLeaveForm.get('kindId')?.value === 2034">
                <label for="remainingAnnualLeave">Kalan Yıllık İzin</label>
                <div class="form-group">
                    <input type="number" class="form-control is-valid" [value]="workerAnnualDay" readonly />
                </div>
            </div>

            <div class="col-12">
                <label for="kindId">İzin Türü</label>
                <div class="form-group">
                    <ng-select [items]="kinds" formControlName="kindId" placeholder="İzin türü seç" bindValue="id"
                        bindLabel="typeName"></ng-select>
                </div>
            </div>

            <div class="form-group col-md-9 col-sm-9">
                <div class="input-group">
                    <input name="datepicker" class="form-control" ngbDatepicker #datepicker="ngbDatepicker"
                        placeholder="yyyy-mm-dd - yyyy-mm-dd" [value]="displayDateRange()" (click)="datepicker.toggle()"
                        (dateSelect)="onDateSelection($event)" [autoClose]="'outside'" [dayTemplate]="rangeSelectionDP"
                        [startDate]="fromDate!" />
                    <ng-template #rangeSelectionDP let-date let-focused="focused">
                        <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null">
                            {{ date.day }}
                        </span>
                    </ng-template>
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary feather icon-calendar" (click)="datepicker.toggle()"
                            type="button"></button>
                    </div>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group">
                    <div class="input-group">
                        <input type="number" class="form-control" readonly id="name" formControlName="leaveDay" />
                    </div>
                </div>
            </div>

            <div class="form-group col-12 d-flex justify-content-between" *ngIf="isDayLeave">
                <ngb-timepicker [(ngModel)]="basicTP" [spinners]="true" (ngModelChange)="updateLeaveDays()"
                    [ngModelOptions]="{ standalone: true }"></ngb-timepicker>

                <ngb-timepicker [(ngModel)]="basicTP2" [spinners]="true" (ngModelChange)="updateLeaveDays()"
                    [ngModelOptions]="{ standalone: true }"></ngb-timepicker>
            </div>

            <div class="form-group col-12" *ngIf="isSameDayLeave">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input"
                        [checked]="isDayLeave" (click)="toggleRadio()" />
                    <label class="custom-control-label" for="customRadio1">Saatlik İzin</label>
                </div>
            </div>
            <div class="form-group col-12">
                <textarea id="note" rows="3" class="form-control" formControlName="description" placeholder="açıklama giriniz"></textarea>
            </div>
            <!-- <div class="col-6" *ngIf="data.row">
                <label for="status">Durum</label>
                <div class="form-group">
                    <ng-select [items]="statusList" formControlName="status" placeholder="Durum seç" bindValue="id"
                        bindLabel="name"></ng-select>
                </div>
            </div> -->
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success"
        [disabled]="!personLeaveForm.valid || !startFilterDate || !startFilterDate" (click)="onSumbit()">{{data.row ?
        'Güncelle' : 'Kaydet'}}</button>
</div>